"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UncontrolledButtonDropdown = _interopRequireDefault(require("reactstrap/lib/UncontrolledButtonDropdown"));

var _utils = require("../lib/utils");

var _DropdownTrigger = _interopRequireDefault(require("./DropdownTrigger"));

var _DropdownMenu = _interopRequireDefault(require("./DropdownMenu"));

require("./dropdown.css");

var Dropdown = function Dropdown(props) {
  var dataTestId = props.dataTestId,
      size = props.size,
      direction = props.direction;
  return /*#__PURE__*/_react["default"].createElement(_UncontrolledButtonDropdown["default"], {
    "data-testid": dataTestId,
    inNavbar: true,
    size: size,
    direction: direction,
    className: (0, _utils.gatherClasses)(props, "oui-btn-droprown")
  }, /*#__PURE__*/_react["default"].createElement(_DropdownTrigger["default"], props), /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], props));
};

Dropdown.propTypes = {
  label: _propTypes["default"].string,
  split: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  disabledMain: _propTypes["default"].bool,
  disabledTrigger: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onItemClick: _propTypes["default"].func,
  rightAligned: _propTypes["default"].bool,
  direction: _propTypes["default"].oneOf(["down", "up"]),
  type: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link", "icon"]),
  size: _propTypes["default"].oneOf(["lg", "md", "sm"]),
  icon: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
    width: _propTypes["default"].string,
    height: _propTypes["default"].string,
    classes: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  items: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({
    label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
    disabled: _propTypes["default"].bool,
    onClick: _propTypes["default"].func
  }), _propTypes["default"].shape({
    divider: _propTypes["default"].bool
  }), _propTypes["default"].shape({
    heading: _propTypes["default"].string,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
      disabled: _propTypes["default"].bool,
      onClick: _propTypes["default"].func
    }))
  })])).isRequired,
  maxMenuHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  dataTestId: _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string
};
Dropdown.defaultProps = {
  split: false,
  direction: "down",
  disabled: false,
  disabledMain: false,
  disabledTrigger: false,
  rightAligned: false,
  type: "primary",
  size: "md",
  maxMenuHeight: 192,
  dataTestId: "orion-dropdown"
};
Dropdown.displayName = "OrionDropdown";
var _default = Dropdown;
exports["default"] = _default;